let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3oWaU")).then(() => parcelRequire('7R82u'));